(function() {
  'use strict';

  var BUNDLE_ID = 10194697519188;
  var BAR_ID = 'aji-upsell-bar';
  var STYLE_ID = 'aji-upsell-bar-styles';
  var busy = false;
  var moved = false;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '@keyframes aji-pulse{0%,100%{background-color:#dc2626}50%{background-color:#991b1b}} @keyframes aji-text-flash{0%,100%{opacity:1}40%{opacity:0.6}}';
    document.head.appendChild(style);
  }

  function bottleCount(cart) {
    return cart.items.reduce(function(n, item) {
      return item.product_id === BUNDLE_ID ? n : n + item.quantity;
    }, 0);
  }

  function paint(bar, n, empty) {
    if (empty || n <= 0) { bar.hidden = true; return; }
    bar.hidden = false;
    if (n === 1) {
      bar.style.cssText = 'background:#dc2626;color:#ffffff;border:none;border-radius:0;padding:16px 20px;margin:0;font-size:16px;font-family:Arial,sans-serif;font-weight:800;text-align:center;line-height:1.4;display:block;width:100%;box-sizing:border-box;animation:aji-pulse 1.4s ease-in-out infinite;letter-spacing:0.01em';
      bar.innerHTML = '<span style="animation:aji-text-flash 1.4s ease-in-out infinite;display:inline-block">🔥 You’re 1 bottle away from 10% OFF — 2 more for free shipping.</span>';
    } else if (n === 2) {
      bar.style.cssText = 'background:#d4e8d8;color:#18412c;border:none;border-bottom:2px solid #18412c;border-radius:0;padding:14px 20px;margin:0;font-size:15px;font-family:Arial,sans-serif;font-weight:700;text-align:center;line-height:1.4;display:block;width:100%;box-sizing:border-box;animation:none';
      bar.innerHTML = '10% off unlocked ✔   Add 1 more bottle → free shipping too.';
    } else {
      bar.style.cssText = 'background:#18412c;color:#ffffff;border:none;border-radius:0;padding:14px 20px;margin:0;font-size:15px;font-family:Arial,sans-serif;font-weight:700;text-align:center;line-height:1.4;display:block;width:100%;box-sizing:border-box;animation:none';
      bar.innerHTML = '10% off + free shipping applied ✔';
    }
  }

  function moveToTop(bar) {
    if (moved) return;
    var footerSection = bar.parentElement;
    if (!footerSection) return;
    var flexContainer = footerSection.parentElement;
    if (!flexContainer) return;
    flexContainer.insertBefore(bar, flexContainer.firstChild);
    moved = true;
  }

  function update() {
    if (busy) return;
    busy = true;
    var bar = document.getElementById(BAR_ID);
    if (!bar) { busy = false; return; }
    moveToTop(bar);
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        paint(bar, bottleCount(cart), cart.item_count === 0);
        busy = false;
      })
      .catch(function() { busy = false; });
  }

  function watchCart() {
    var slot = document.getElementById('right-drawer-slot');
    if (slot) {
      new MutationObserver(update).observe(slot, { childList: true, subtree: true });
    }
    ['cart:updated', 'cart:item-added', 'cart:item-removed', 'cart:refresh'].forEach(function(e) {
      document.addEventListener(e, update);
    });
  }

  function waitForBar() {
    injectStyles();
    if (document.getElementById(BAR_ID)) {
      update();
      watchCart();
      return;
    }
    var observer = new MutationObserver(function() {
      if (document.getElementById(BAR_ID)) {
        observer.disconnect();
        update();
        watchCart();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 10000);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', waitForBar)
    : waitForBar();
})();
